<h4 class="dialogHeadlineGenerique" mat-dialog-title>Select influencer</h4>
<mat-dialog-content style="width: auto;height: auto;" class=" mt-2">
    <p class="mt-1">Select influencer</p>
    <select class="form-control mb-1" [(ngModel)]="selectedDevice" (ngModelChange)="onChange()">
        <option value=""></option>
        <option *ngFor="let x of campagne ; index as i" [ngValue]="x" (click)="openNewTabOfferDetails(x)" >{{x.name}}</option>
    </select>
    
</mat-dialog-content>